import {FC, useState, useEffect, useRef} from 'react'
import {Modal} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import {toast} from 'react-toastify'
import './style.css'
import {Page, Document} from 'react-pdf'
import {clearLocalStorageExcept} from 'thesis-and-dissertations/helpers/helper'
const api = new Api()

type Props = {
  showLetterModal: boolean
  handleCloseLetterModal: any
  currentLetter: any
  currentPage: string
}

const LetterModalContent: FC<Props> = ({
  showLetterModal,
  handleCloseLetterModal,
  currentLetter,
  currentPage,
}) => {
  const navigate = useNavigate()
  const [showModal, setShowModal] = useState<any>(false)
  const [loading, setLoading] = useState(false)
  const [file, setFile] = useState('')
  const [numPages, setNumPages] = useState(null)
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false)
  const scrollRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    setShowModal(showLetterModal)
  }, [showLetterModal])

  useEffect(() => {
    loadPdf(currentLetter?.title)
  }, [currentLetter])

  useEffect(() => {
    const handleScroll = () => {
      const container = scrollRef.current
      if (!container) return

      const {scrollTop, scrollHeight, clientHeight} = container
      const isBottom = scrollTop + clientHeight >= scrollHeight - 10
      setIsScrolledToBottom(isBottom)
    }

    const scrollContainer = scrollRef.current
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener('scroll', handleScroll)
      }
    }
  }, [file, numPages])

  const handleClose = () => {
    setShowModal(false)
    handleCloseLetterModal(false)
  }

  const loadPdf = (type: string) => {
    switch (type) {
      case 'Pakta Integritas':
        fetchIntegrityFacts()
        break
      case 'Berita Acara':
        setFile('')
        break
      case 'BA PROPOSAL':
        actionBa({}, true)
        break
      case 'BA SUBSTANSI':
        actionBa({}, false)
        break
      case 'Export Excel':
        setShowModal(false)
        fetctExcel()
        break
      default:
        setFile('')
        break
    }
  }

  const fetctExcel = () => {
    setLoading(true)
    api
      .exportExcel({role: currentPage})
      .then((response: any) => {
        setLoading(false)
        const {data} = response.data
        downloadExcel(data?.file, data?.name)
      })
      .catch((error: any) => {
        setLoading(false)
      })
  }

  const downloadExcel = (file: any, fileName: string) => {
    const link = document.createElement('a')
    link.href = file // langsung pakai base64 full
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const fetchIntegrityFacts = () => {
    setLoading(true)
    api
      .getIntegrityFacts()
      .then((response: any) => {
        setLoading(false)
        const {data} = response.data
        setFile(data?.file)
      })
      .catch((error: any) => {
        setLoading(false)
      })
  }

  const onDocumentLoadSuccess = ({numPages}: any) => {
    setNumPages(numPages)
  }

  const actionBa = (payload: any, isProposal = true) => {
    let baseApi

    if (isProposal) {
      baseApi = api.saveBaProposal(payload)
    } else {
      baseApi = api.saveBaInterview(payload)
    }

    baseApi
      .then((response: any) => {
        setLoading(false)

        if (payload?.is_ba_approval) {
          handleClose()
          return
        }

        const {data} = response.data
        setFile(data?.file)
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error?.response
        toast.error(data?.message ?? data?.meta?.message)

        if (status == 401) {
          clearLocalStorageExcept()
          window.location.reload()
        }
      })
  }

  const integrityFacts = () => {
    setLoading(true)
    api
      .saveIntegrityFacts({is_setuju: true})
      .then(() => {
        setLoading(false)
        handleClose()
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error?.response
        toast.error(data?.message ?? data?.meta?.message)

        if (status == 401) {
          clearLocalStorageExcept()
          window.location.reload()
        }
      })
  }

  const agreementAction = () => {
    switch (currentLetter?.title) {
      case 'Pakta Integritas':
        integrityFacts()
        break
      case 'Berita Acara':
        handleClose()
        break
      case 'BA PROPOSAL':
        actionBa({is_ba_approval: 1}, true)
        break
      case 'BA SUBSTANSI':
        actionBa({is_ba_approval: 1}, false)
        break
      default:
        handleClose()
        break
    }
  }

  return (
    <Modal show={showModal} centered size='lg' dialogClassName='custom-modal-scroll'>
      {!currentLetter?.buttonText && (
        <div className='text-end px-5 pt-5' style={{cursor: 'pointer'}} onClick={handleClose}>
          <i className='fa fa-close text-black'></i>
        </div>
      )}

      <div className='p-3 p-md-5'>
        <div
          ref={scrollRef}
          style={{
            maxHeight: '70vh',
            overflowY: 'auto',
            paddingRight: '10px',
            marginBottom: '20px',
            borderRadius: '8px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
            border: '1px solid #f0f0f0',
          }}
        >
          {file && (
            <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
              {numPages &&
                Array.from(new Array(numPages), (el, index) => (
                  <div key={`page_${index + 1}`} style={{marginBottom: '40px'}}>
                    <Page pageNumber={index + 1} width={600} />
                    {index + 1 < numPages && (
                      <hr style={{marginTop: '20px', border: '1px solid #ccc'}} />
                    )}
                  </div>
                ))}
            </Document>
          )}
        </div>

        {currentLetter?.buttonText && (
          <div
            className='d-flex justify-content-center mt-4'
            style={{
              position: 'sticky',
              bottom: 0,
              background: '#fff',
              padding: '10px',
              zIndex: 20,
            }}
          >
            <button
              className='btn btn-primary btn-sm'
              disabled={loading || !isScrolledToBottom}
              onClick={agreementAction}
              style={{zIndex: 10}}
            >
              {loading ? 'Loading...' : currentLetter.buttonText}
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

const LetterModal: FC<Props> = ({
  showLetterModal,
  handleCloseLetterModal,
  currentLetter,
  currentPage,
}) => {
  return (
    <LetterModalContent
      showLetterModal={showLetterModal}
      handleCloseLetterModal={handleCloseLetterModal}
      currentLetter={currentLetter}
      currentPage={currentPage}
    />
  )
}

export default LetterModal
